import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typo } from '@ers/ui/';

const Checkbox = ({ id, children, checked, onChange, radio, center, disabled }) => (
    <div className="checkbox" key={`checkboxId__${id}`}>
        <input
            id={id} type={radio ? 'radio' : 'checkbox'}
            className="checkbox__input"
            checked={checked} onChange={onChange}
            disabled={disabled}
        />
        <label
            htmlFor={id} className={cx('checkbox__label',
                { 'checkbox__label--center': center, 'checkbox__label--tick': !center && !radio, 'checkbox__label--round': radio, 'checkbox__label--disabled': disabled })}
        >
            <Typo.Body key={`typoCheckboxId__${id}`}>{children}</Typo.Body>
        </label>
    </div>
);

Checkbox.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired,
    center: PropTypes.bool,
    radio: PropTypes.bool,
    disabled: PropTypes.bool
};

Checkbox.defaultProps = {
    center: false,
    radio: false,
    disabled: false
};

export default Checkbox;
